module.exports = __webpack_public_path__ + "static/media/home15.ea52bc38.jpg";